import React, { FC } from 'react';
import { getDurationNicknameFromMs } from '@fullstory/util/date';
import { Box, InlineLink } from '@fullstory/components';
import { UserVariableItem } from '../UserVariableItem';
import { UserDetailsResponse } from '@fullstory/client-api';
import { useIntl } from 'react-intl';
import css from './userOverlayDetails.module.scss';

type UserOverlayDetailsProps = {
  userDetails: UserDetailsResponse;
  userMetadata: {
    [key: string]: string;
  };
};

export const UserOverlayDetails: FC<UserOverlayDetailsProps> = ({ userDetails, userMetadata }) => {
  const intl = useIntl();
  return (
    <Box data-component="UserOverlayDetails" padding={24} width={1} className={css.gridContainer}>
      {userDetails.UserAppId && (
        <UserVariableItem
          property={intl.formatMessage({ defaultMessage: 'User Id', id: 'TFIy4B' })}
          value={userDetails.UserAppId}
        />
      )}
      {userDetails.UserEmail && (
        <UserVariableItem
          property={intl.formatMessage({ defaultMessage: 'Email', id: 'sy+pv5' })}
          value={userDetails.UserEmail}
        />
      )}
      {Object.keys(userMetadata).map(key => (
        <UserVariableItem key={key} property={key} value={userMetadata[key]} />
      ))}
      {Object.keys(userDetails.IntegrationUrls).map(key => {
        const integrationLink = userDetails.IntegrationUrls[key]!;
        return (
          <UserVariableItem
            key={key}
            property={key}
            value={
              <InlineLink href={integrationLink.LinkUrl} newTab>
                {integrationLink.LinkText}
              </InlineLink>
            }
          />
        );
      })}
      <UserVariableItem
        property={intl.formatMessage({ defaultMessage: 'Total in-app time', id: 'telkRi' })}
        value={getDurationNicknameFromMs(userDetails.UserTotalSec * 1000)}
      />
      {userDetails.TotalSessionCount > 0 ? (
        <>
          <UserVariableItem
            property={intl.formatMessage({
              defaultMessage: 'Average session length',
              id: 'STHpH/',
            })}
            value={getDurationNicknameFromMs(
              (userDetails.UserTotalSec / userDetails.TotalSessionCount) * 1000,
            )}
          />
          <UserVariableItem
            property={intl.formatMessage({
              defaultMessage: 'Average events per session',
              id: 'l9zkN5',
            })}
            value={`${Math.round(userDetails.UserNumEvents / userDetails.TotalSessionCount)}`}
          />
        </>
      ) : null}
    </Box>
  );
};
